module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_vm._m(0), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('i', {
    staticClass: "ti-home"
  })])], 1), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Vue Bar")])])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('bars', {
    attrs: {
      "data": [1, 2, 5, 9, 5, 10, 3, 5, 2, 5, 1, 8, 2, 9, 0],
      "gradient": ['#000000', '#000000']
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('bars', {
    attrs: {
      "data": [4, 2, 5, 9, 5, 10, 3, 5, 2, 5, 9, 8, 2, 9, 4, 5, 6, 9, 5, 9, 6, 4, 9, 6, 9, 5, 4, 6, 5, 4],
      "gradient": ['#6fa8dc', '#42b983']
    }
  })], 1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', [_vm._v("Vue Bar"), _c('small', [_vm._v("Input data using mouse or keyboard. "), _c('i', {
    staticClass: "ti-heart"
  }), _c('i', {
    staticClass: "ti-export"
  }), _c('i', {
    staticClass: "ti-printer"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Charts")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("VueBar Option 1")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse",
      "data-toggle": "tooltip",
      "title": "Collapse"
    }
  }, [_c('i', {
    staticClass: "fa ti-minus"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "remove",
      "data-toggle": "tooltip",
      "title": "Remove"
    }
  }, [_c('i', {
    staticClass: "fa ti-close"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("VueBar Option 2")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse",
      "data-toggle": "tooltip",
      "title": "Collapse"
    }
  }, [_c('i', {
    staticClass: "fa ti-minus"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "remove",
      "data-toggle": "tooltip",
      "title": "Remove"
    }
  }, [_c('i', {
    staticClass: "fa ti-close"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-92dc67f2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/chart/VueBar.vue
// module id = 1318
// module chunks = 2